import { useState, useCallback, useEffect } from 'react';
import axios from 'axios';

export function useQcDeviceHistory(serialNumber) {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    if (!serialNumber) {

      console.log('[useQcDeviceHistory] No serialNumber provided, skipping fetch');
      return;
    }
    setIsLoading(true);
    setError(null);
    try {
      const token = localStorage.getItem('jwtToken') || null;
      const url = `${process.env.REACT_APP_BASE_URL}/apps/api/qc/devices/${serialNumber}/history`;

      console.log('[useQcDeviceHistory] Making request to:', url);
      const headers = { Authorization: `Bearer ${token}` };
      const response = await axios.get(url, { headers });

      console.log('[useQcDeviceHistory] Response received:', response.data);
      setData(response.data);
      return response.data;
    } catch (err) {

      console.log('[useQcDeviceHistory] Error:', err);
      setError(err?.message);
      setData(null);
    } finally {
      setIsLoading(false);
    }
  }, [serialNumber]);

  useEffect(() => {

    console.log('[useQcDeviceHistory] useEffect triggered, serialNumber:', serialNumber);
    fetchData();
  }, [fetchData]);

  return { isLoading, data, error, refetch: fetchData };
} 